// Module
var code = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M327.51 432.969L150.54 255.999L327.51 79.0293L361.46 112.969L218.43 255.999L361.46 399.029L327.51 432.969Z\"/> </svg> ";
// Exports
module.exports = code;